<template>
  <div>
    <!-- <p class="c-inner-title">标签管理</p> -->
    <div class="auto">
      <page-title title="标签管理" icon="fa-cog"></page-title>
    </div>
    <el-row class="box-row m-t-15">
      <el-col class="box-col" :span="24">
        <div class="table-wrap">
          <el-row class="table-control">
            <el-col :span="12">
              <el-button type="primary" @click="handle" class="el-icon-plus" size="small"> 添加标签</el-button>
            </el-col>
            <el-col :span="12" class="flex-box j-c-e">
              <el-select v-model="filter.type_id" placeholder="选择分类" size="small">
                <el-option
                  key=""
                  label="全部"
                  value="">
                </el-option>
                <el-option
                  v-for="item in typeOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="String(item.id)">
                </el-option>
              </el-select>
              <el-input placeholder="搜索名称" v-model.trim="filter.search" clearable class="m-lr-5" style="width:200px;" size="small"></el-input>
              <el-button type="primary" @click="handleChangeFilter" size="small">搜索</el-button>
            </el-col>
          </el-row>
          <el-table
            :data="tableData"
            style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="id" label="ID" width="250"></el-table-column>
            <el-table-column prop="name" label="名称" width="180"></el-table-column>
            <el-table-column prop="type.name" label="分类"></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column label="操作" width="240">
              <template slot-scope="scope">
                <el-button
                  @click="handle(scope.$index, tableData)"
                  type="primary"
                  size="small">
                  修改配置
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="total > filter.limit" class="main-page m-t-10 p-none">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="Number(filter.page)"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="Number(filter.limit)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="标签操作" :modal-append-to-body="false" :visible.sync="dialogVisible">
      <el-form ref="form" :rules="rules" :model="form" label-width="100px" size="small">
        <el-form-item prop="name" label="名称">
          <el-input v-model.trim="form.name"></el-input>
        </el-form-item>
        <el-form-item prop="type_id" label="分类">
          <el-select v-model="form.type_id" filterable placeholder="请选择分类">
            <el-option
              v-for="item in typeOptions"
              :key="item.id"
              :label="item.name"
              :value="String(item.id)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input type="textarea" v-model.trim="form.remark"></el-input>
        </el-form-item>
        <el-form-item prop="id" label="id" v-show="false">
          <el-input v-model.trim="form.id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit('form')" :loading="btnLoading">提交</el-button>
          <el-button @click="handleExit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {Setting} from '@/model'
export default {
  data () {
    return {
      dialogVisible: false,
      tableData: [],
      search: '',
      form: {
        id: '',
        name: '',
        remark: '',
        type_id: ''
      },
      rules: {
        name: [
          { required: true, message: '名称不能为空！', trigger: 'blur' }
        ],
        type_id: [
          { required: true, message: '分类不能为空！', trigger: 'blur' }
        ]
      },
      loading: false,
      typeId: '',
      formClone: {},
      typeOptions: [],
      pageSize: 50,
      currentPage: 0,
      totalData: [],
      btnLoading: false,
      filter: {
        type_id: '',
        search: '',
        page: '1',
        limit: '20'
      },
      total: 0
    }
  },
  watch: {
    '$route': function () {
      this.queryToFilter()
    }
  },
  methods: {
    handleChangeFilter () {
      this.filter['page'] = 1
      this.filterHandle()
    },
    resetFilter () {
      this.filter = {
        type: '',
        search: '',
        page: '1',
        limit: '20'
      }
      this.filterHandle()
    },
    filterHandle () {
      this.$router.replace({path: '/setting/tag/manage', query: this.filter})
    },
    queryToFilter () {
      let filter = JSON.parse(JSON.stringify(this.$route.query))
      for (let k in this.filter) {
        if (!filter[k]) {
          filter[k] = this.filter[k]
        }
      }
      this.filter = filter
      this.handleList()
    },
    handleSizeChange (val) {
      this.filter['page'] = 1
      this.filter['limit'] = val
      this.filterHandle()
    },
    handleCurrentChange (val) {
      this.filter['page'] = val
      this.filterHandle()
    },
    handle (index, data) {
      var row = Object.assign({}, this.formClone)
      if (index > -1) {
        row = Object.assign({}, data[index])
      }
      this.form = row
      this.dialogVisible = true
    },
    handleSubmit (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid && this.form.name.trim()) {
          delete this.form.type_name
          delete this.form.create_time
          delete this.form.type
          this.btnLoading = true
          var res = await Setting.doTagSubmit(this.form)
          this.btnLoading = false
          if (res !== false && res['err_code'] === 0) {
            this.$message.success('提交成功!')
            this.dialogVisible = false
            if (this.form.id === '') {
              this.resetFilter()
            }
            this.handleList()
          } else {
            this.$message.error(res['err_msg'])
          }
        }
      })
    },
    handleExit () {
      this.dialogVisible = false
    },
    async getTagTypeList () {
      this.loading = true
      let res = await Setting.getTagTypeList()
      this.loading = false
      if (res !== false && res['err_code'] === 0) {
        let typeOptions = [...res['data']['list']]
        this.typeOptions = typeOptions
      } else {
        this.$message.error(res['err_msg'])
      }
    },
    async handleList () {
      this.loading = true
      var res = await Setting.tagIndex(this.filter)
      this.loading = false
      if (res !== false && !res['err_code']) {
        this.tableData = res['data']['list']
        this.total = res['data']['total']
      } else {
        this.$message.error(res['err_msg'])
      }
    }
  },
  created () {
    this.formClone = Object.assign({}, this.form)
    this.queryToFilter()
    this.getTagTypeList()
  }
}
</script>

<style scoped>
.el-tag { margin-right: 5px; }
.el-checkbox.el-checkbox-rigth { margin-left: 0; margin-right: 15px; }
</style>
